import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

const useCurrencyService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingCurrentValue, setFetchingCurrentValue] = useState(false);
    const [fetchingGetExchanges, setFetchingGetExchanges] = useState(false);
    const [fetchingStoreExchange, setFetchingStoreExchange] = useState(false);
    const [fetchingGetCurrencies, setFetchingGetCurrencies] = useState(false);

    const BASE_PATH = 'currencies';

    /**
     * Obtiene el último valor de una moneda hasta el día actual
     * @param currencyName - Nombre de la moneda (ej: 'UTM', 'UF', 'USD')
     * @param events - Eventos de callbacks
     */
    const getCurrentCurrencyValue = (currencyName: string, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/foreign-exchanges/current/${currencyName}`),
            setFetching: setFetchingCurrentValue
        });
    };

    /**
     * Obtiene todas las monedas activas
     */
    const getCurrencies = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/currencies`),
            setFetching: setFetchingGetCurrencies
        });
    };

    /**
     * Obtiene el listado de valores de conversión (foreign exchanges)
     */
    const getForeignExchanges = (filters: any, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([_, value]) => value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
            
        doGet({
            ...events,
            url: `${buildEndpoint(`${BASE_PATH}/foreign-exchanges`)}?${queryString}`,
            setFetching: setFetchingGetExchanges
        });
    };

    /**
     * Crea un nuevo valor de conversión manualmente
     */
    const storeExchangeManually = (data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/foreign-exchanges/manually-store`),
            body: data,
            setFetching: setFetchingStoreExchange
        });
    };

    return {
        getCurrentCurrencyValue,
        getCurrencies,
        getForeignExchanges,
        storeExchangeManually,
        fetchingCurrentValue,
        fetchingGetCurrencies,
        fetchingGetExchanges,
        fetchingStoreExchange
    };
};

export default useCurrencyService;


